export class ListGdsgEnvironmentsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "environments",
            "baseName": "environments",
            "type": "Array<GdsgEnvironment>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGdsgEnvironmentsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
